import isServerSide from '../../../../modules/is-server-side'

const getExperienceTags = () => {
  if (!isServerSide()) {
    const tags = window.tp && window.tp.tags
    return tags.split(',')
  }
  return false
}

export default getExperienceTags
